<template>
  <div class="p-3">
    <b-modal id="modal-explain" hide-header hide-footer size="lg">
      <question-explain></question-explain>
    </b-modal>
    <!-- <div id="pop-up" v-if="loading == true">
      <div class="">
        <b-spinner
          variant="primary"
          style="width: 4rem; height: 4rem"
          label=""
        ></b-spinner>
      </div>
    </div> -->
    <div id="pop-up" v-if="loading">
      <div class="overlay-content">
        <div class="circle">
          <svg width="120" height="120">
            <circle
              cx="60"
              cy="60"
              r="50"
              stroke="#eee"
              stroke-width="10"
              fill="none"
            />
            <circle
              cx="60"
              cy="60"
              r="50"
              stroke="#1890ff"
              stroke-width="10"
              fill="none"
              stroke-linecap="round"
              :stroke-dasharray="314"
              :stroke-dashoffset="314 - (314 * progress) / 100"
            />
          </svg>

          <div class="circle-text">
            {{ Math.floor(progress) }}%
          </div>
        </div>
      </div>
    </div>
    <div class="createQuestion">
      <h5>{{ $t("question_list.create_new_question") }}</h5>
      <div class="">
        <div class="d-flex align-items-center justify-content-between">
          <div class="d-flex mt-3 mb-3 align-items-center">
            <p class="pr-2 text-nowrap">
              {{ $t("question_list.label.category") }}:
            </p>
            <!--                        1-->
            <multiselect
              v-model="cateSelected"
              :close-on-select="true"
              :clear-on-select="false"
              label="category"
              :multiple="true"
              :options="category"
              :placeholder="$t('question_list.label.placeholder_category')"
              track-by="category"
              :hide-selected="true"
              :max-height="150"
              class=""
              @select="checkCategoryPermission"
            >
            </multiselect>
          </div>
          <!-- <div class="d-flex align-items-center">
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.type") }}:</p>
              <select class="createQuestion-dropdown" @change="typeOfQuestion">
                <option v-for="num in typeOfQuestions" :key="num.id" value="">
                  {{ num }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2" v-if="form.type != 'Writing' && form.type != 'Speaking'">
                {{ $t("question_list.label.answer") }}:
              </p>
              <select
                v-if="form.type != 'Writing' && form.type != 'Speaking'"
                class="createQuestion-dropdown"
                @change="alphabetOfQuestion"
              >
                <option v-for="num in typeOfAnswers" :key="num.id" value="">
                  {{ num }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.difficulty") }}:</p>
              <select
                class="createQuestion-dropdown"
                @change="difficultyOfQuestion"
              >
                <option v-for="num in difficulty" :key="num.id" value="">
                  {{ num.difficulty }}
                </option>
              </select>
            </div>
            <div class="d-flex align-items-center my-4 px-3">
              <p class="pr-2">{{ $t("question_list.label.score") }}:</p>
              <input
                v-model="form.score"
                type="number"
                placeholder="0"
                class="createQuestion-dropdown p-3"
                style="width: 70px"
              />
            </div>
          </div> -->
        </div>

        <!-- <div class="row justify-content-around">
            <div class="col-4 p-0"></div>
            <div class="col-8 d-flex align-items-center justify-content-end mb-4">
                <div class="col-8 d-flex align-items-center p-0">
                    <label class="typo__label mr-2">Tags:</label>
                    <multiselect
                        v-model="tagsSelected"
                        :placeholder="$t('question_list.label.placeholder_category')"
                        label="name"
                        track-by="id"
                        :options="optionsTags"
                        :multiple="true"
                        :taggable="true"
                        :close-on-select="true"
                        :clear-on-select="false"
                        :hide-selected="true"
                        :max-height="150"
                    >
                    </multiselect>

                </div>
            </div>
        </div> -->

        <div class="row justify-content-around">
          <div class="col left-embed p-0">
            <!-- //embed video/image -->
            <!--                        4-->
            <div class="title-topic__textArena">
              <textarea
                v-model="titleTopic"
                class="p-1 w-100"
                disabled
                rows="1"
                maxlength="1500"
                :placeholder="$t('question_list.label.placeholder_title')"
              ></textarea>
            </div>
            <div
              class="d-flex flex-column align-items-center embed-image-video topicDetail"
            >
              <ion-icon
                style="font-size: 60px; margin-bottom: 10px"
                name="cloud-upload-outline"
                v-if="!imageUpload && !file && !embedUpload && !pdfPreview && !docxPreview"
              ></ion-icon>
              <label
                v-if="!imageUpload && !file && !embedUpload && !pdfPreview && !docxPreview"
                class="label-uploadImage"
                for="uploadImage"
                >
                <!-- {{ $t("question_list.label.upload_file") }} -->
                Chọn file đề thi
                </label
              >
              <input
                v-if="!imageUpload && !file && !embedUpload && !pdfPreview && !docxPreview"
                type="file"
                @change="handleFileUpload"
                id="uploadImage"
              />
              <div v-if="imageUpload || file || pdfPreview || docxPreview" id="preview" >
                <img v-if="imageUpload" :src="imageUpload" />
                <video
                  style="width:100%; height:100%;"
                  v-if="file"
                  :src="file"
                  controls
                  id="video-preview"
                ></video>
                <iframe
                    v-if="pdfPreview"
                    :src="pdfPreview"
                    width="100%"
                    height="500px">
                </iframe>
                <div v-if="pdfPreview">
                    <i class="fa fa-file-word"></i> {{ this.form.pdf_path.name }}
                </div>
                <div v-if="form.docx_path && docxPreview">
                    <i class="fa fa-file-word"></i> {{ docxPreview }}
                </div>
                <button @click="removeFile">X</button>
              </div>

              <button id="removeEmbed" v-if="embedUpload" @click="removeEmbed">
                X
              </button>
              <!--                            5-->
              <!-- <div id="embedUpload_topic"></div>
              <div
                v-if="!imageUpload && !file"
                class="d-flex justify-content-between embed-image my-2"
              >
                <input v-model="form.embed_image_video" type="text"  v-if="!embedUpload"/>
                <button @click="embed()"  v-if="!embedUpload">
                  {{ $t("question_list.label.embed_image") }}
                </button>
              </div> -->
            </div>
            <div class="col col-6" v-if="pdfPreview">
                <label for="start_page">Trang bắt đầu:</label>
                <b-input id="start_page" v-model="form.start_page" placeholder="Nhập trang số ... của file đề thi" type="number" />
                 <label for="end_page">Trang kết thúc:</label>
                <b-input id="end_page" v-model="form.end_page" placeholder="Nhập trang số ... của file đề thi" type="number" />
            </div>
          </div>
          <div class="col" style="display: none;">
            <div
              v-if="embedAudio === ''"
              class="d-flex align-items-center justify-content-between mb-4"
            >
              <div class="upload-audio">
                <button
                  class="upload-audio-button"
                  for="upload-audio-input-topic"
                  type="button"
                >
                  <b-icon
                    icon="music-note-beamed"
                    font-scale="1.5"
                    style="margin-right: 5px"
                    variant="danger"
                  ></b-icon>
                  <label style="white-space: nowrap;" for="upload-audio-input-topic">{{
                    $t("question_list.label.audio")
                  }}</label>
                </button>
                <!--                                6-->
                <b-form-file
                  accept="audio/*"
                  @change="handleAudioUpload($event)"
                  class="pr-1"
                  id="upload-audio-input-topic"
                ></b-form-file>
              </div>
              <audio
                id="form"
                :src="audioUpload"
                controls
                v-show="audioUpload != ''"
              />
              <ion-icon
                @click="removeAudio"
                v-show="audioUpload != ''"
                name="close-circle-outline"
                style="font-size: 30px"
              ></ion-icon>
            </div>
            <div v-if="audioUpload == ''" class="embed-audio">
              <div class="embed-input">
                <b-button @click="audioEmbedLeft">
                  <b-icon
                    icon="box-arrow-up"
                    font-scale="1.2"
                    variant="success"
                  ></b-icon>
                  <span>{{ $t("question_list.label.embed_video_audio") }}</span>
                </b-button>
                <!--                            8-->

                <input
                  v-model="form.embed_audio"
                  type="text"
                  id="embed_audio_link"
                  :placeholder="$t('question_list.label.embed_video_audio_placeHolder')"
                  class="ml-2"
                />
              </div>
              <div id="audio_embed_view_topic"></div>
              <ion-icon
                class="remove-embed-audio-btn"
                @click="removeEmbedAudio"
                v-show="embedAudio != ''"
                name="close-circle-outline"
              ></ion-icon>
            </div>
            <!--                        9-->
            <div class="answer-options d-flex" v-if="form.type != 'Writing' && form.type != 'Speaking'">
              <p class="text-nowrap">
                {{ $t("question_list.label.answer_option") }}:
              </p>
              <select class="" @change="manyAnswerOfQuestion">
                <option v-for="num in answerOptionOfQuestions" :key="num.id">
                  {{ num }}
                </option>
              </select>
              <p class="ml-5 text-nowrap" style="width: 17%;">
                {{ $t("question_list.label.answer_type") }}:
              </p>
              <select class="" @change="answerTypeOfQuestion">
                <option
                  v-for="num in answerTypeOfQuestions"
                  :key="num.id"
                  value=""
                >
                  {{ num }}
                </option>
              </select>
            </div>
            <!--                        10-->
            <div class="question-input__textArena">
              <ckeditor
                :config="editorConfig"
                :editor="editor"
                @ready="onReady"
                v-model="form.title"
                @input="charCountTitle()"
                name=""
                id=""
                class="w-100"
                rows="3"
                maxlength="1500"
                :placeholder="$t('question_list.label.placeholder_title')"
              ></ckeditor>
              <!-- <span>{{ totalCharacter }} / 1500</span> -->
            </div>
            <div
              class="w-100 justify-content-between d-flex align-items-center mt-3"
            >
              <button v-b-modal.modal-explain class="btn-explanation">
                {{ $t("question_list.label.explanation") }}
              </button>
              <div class="d-flex align-items-center">
                <!--                                11-->
                <p v-if="form.type != 'Writing' && form.type != 'Speaking'" class="pr-1">
                  {{ $t("question_list.label.number_answer") }}:
                </p>
                <select
                  v-if="form.type != 'Writing' && form.type != 'Speaking'"
                  class="createQuestion-dropdown"
                  @change="numberAnswerOfQuestion"
                  v-model="defaultNumberAnswer"
                >
                  <option v-for="num in numberAnswerOfQuestions" :key="num.id">
                    {{ num }}
                  </option>
                </select>
              </div>
              <!--                            12-->
              <div class="d-flex align-items-center">
                <p class="pr-1">{{ $t("question_list.label.status") }}:</p>
                <select
                  class="createQuestion-dropdown"
                  id=""
                  @change="statusOfQuestion"
                  v-model="form.status"
                >
                  <option
                    v-for="stt in statusOfQuestions"
                    :key="stt.id"
                    :value="stt.value"
                  >
                    {{ stt.text }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <h5 style="display: none;" v-if="form.type != 'Writing' && form.type != 'Speaking'" class="pt-2">
        {{ $t("question_list.label.answer") }}
      </h5>
      <div
        style="display: none;"
        :key="imageReRender"
        v-if="form.type != 'Writing' && form.type != 'Speaking'"
        class="formCreateQuestion"
      >
        <!--                13-->
        <div
          v-for="(num, index) in valueTypeOfAnswer"
          :key="index"
          class="answerQuestion m-1"
        >
          <p>{{ valueTypeOfAnswer[index] }}.</p>
          <div
            v-if="!answerUpload[index] && isText == false"
            class="d-flex align-items-center justify-content-center h-100"
          >
            <label for="upload-image__invisible">
              <ion-icon
                name="cloud-upload-outline"
                @click="uploadImageAnswer(index)"
                style="font-size: 30px"
              ></ion-icon>
            </label>
            <input
              type="file"
              @change="handleAnswerUpload($event, index)"
              class="upload-image__invisible"
              :id="'uploadImage' + index"
            />
          </div>
          <div v-if="isText == null" class="option-question">
            <!-- Add Answer -->
            <button v-if="isText == null" class="answer-input">
              {{ $t("question_list.label.answer") }}
            </button>

            <!-- Image Upload -->
            <ion-icon
              v-if="isText == null"
              name="image-outline"
              class="answer-image"
              style="font-size: 40px; width: 50%"
            >
            </ion-icon>
          </div>
          <!--                    14-->
          <div v-show="isText == true" class="mt-2">
            <ckeditor
              :config="editorConfig"
              :editor="editor"
              @ready="onReady"
              v-model="form.answer_text[index]"
              name=""
              id=""
              rows="3"
              maxlength="1500"
              :placeholder="$t('question_list.label.placeholder_answer')"
              class="answer-input__text "
            ></ckeditor>
          </div>
          <div
            style=""
            v-if="answerUpload[index] && isText == false"
            class=""
            :id="'preview' + index"
          >
            <img :src="answerUpload[index]" />
            <button @click="removeAnswerImage(index)">
              {{ $t("question_list.label.remove_image") }}
            </button>
          </div>
          <!-- Choose Input -->
          <div
            :key="updateCorrectAnswer"
            class="text-answer"
            v-if="isText != null"
          >
            <input
              v-if="form.answer_option == 'Multiple choice'"
              type="checkbox"
              name="checkbox"
              id="checkbox"
              @change="getMultiCorrectAnswer(index)"
              class="checkboxInvisible m-3"
              :checked="isTrueSet[index]"
            />
            <input
              v-if="form.answer_option == 'One choice'"
              type="radio"
              name="radio"
              id="checked-radio"
              class="checked m-3"
              @change="getCorrectAnswer(index)"
              :checked="isTrueSet[index]"
            />
          </div>
        </div>
      </div>
      <div class="mt-3 float-right">
        <b-button @click="hideModal" variant="danger">{{
          $t("question_list.label.cancel")
        }}</b-button>
        <b-button
          v-if="disable == true"
          @click="CreateQuestions()"
          style="margin-left: 1rem"
          variant="primary"
          >{{ $t("question_list.label.save") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Multiselect from "vue-multiselect";
import QuestionExplain from "./QuestionExplainModal.vue";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import axios from "axios";

export default {
  props: {
    callback: Function,
    rowTopicItem: Number,
    titleTopic: Text
  },
  components: {
    Multiselect,
    QuestionExplain
  },
  data() {
    return {
        optionsTags: [],

        editor: DecoupledEditor,
        editorConfig: {
            toolbar: [ 'bold', 'italic','underline'],
            placeholder: this.$t('question_list.label.placeholder_title')
        },
        editorConfigAnswer: {
            toolbar: ['bold', 'italic', 'underline'],
            placeholder: this.$t("question_list.label.placeholder_answer")
        },
      disable: true,
      loading: false,
      isTrueSet: [],
      updateCorrectAnswer: 0,
      isText: true,
      imageReRender: 0,
      cateSelected: [],
      tagsSelected: [],
      defaultNumberAnswer: 4,
      typeOfQuestions: ["Listening", "Writing", "Reading", "Speaking"],
      alphabetAnswerSelected: 0,
      typeOfAnswers: ["Alphabet", "Number"],
      statusOfQuestions: [
        { text: "Active", value: 0 },
        { text: "Inactive", value: 1 }
      ],
      answerOptionOfQuestions: ["One choice", "Multiple choice"],
      answerTypeOfQuestions: ["Text", "Images"],
      numberAnswerOfQuestions: [1, 2, 3, 4, 5, 6],
      valueTypeOfAnswers: [
        ["A", "B", "C", "D", "E", "F"],
        [1, 2, 3, 4, 5, 6]
      ],
      valueTypeOfAnswer: ["A", "B", "C", "D"],
      imageUpload: "",
      embedUpload: "",
      audioUpload: "",
      embedAudio: "",
      totalCharacter: 0,
      answerUpload: [],
      correctAnswer: [],
      file: "",
      pdfPreview: "",
      docxPreview: "",
      filterData: {
        search: "",
        page: 1,
        selected: {
          category: "",
          typeQuestion: "",
          typeOfQuestion: "",
          difficulty: "",
          score: "",
          tags: ""
        }
      },
      form: {
        title: "",
        type: "Listening",
        status: 0,
        score: "",
        difficulty: "",
        category: [],
        image_path: "",
        video_path: "",
        embed_image_video: "",
        audio_path: "",
        embed_audio: "",
        answer_option: "One choice",
        answer: [],
        image: [],
        answer_text: [],
        number_answer: 4,
        tags: [],
        start_page: "",
        end_page: "",
        pdf_path: "",
        docx_path: "",
      },
      progress: 0,
      fakeProgress: 0
    };
  },
  computed: {
    ...mapState("config", ["category", "difficulty"]),
    ...mapState("question", ["explain", "explain_path", "changeListTags"]),
    ...mapState("auth", ["user"]),

    categoryIdsAllow() {
      return this.user?.category_ids_apply || "";
    }
  },
  methods: {
      onReady(editor) {
          editor.ui
              .getEditableElement()
              .parentElement.insertBefore(
              editor.ui.view.toolbar.element,
              editor.ui.getEditableElement()
          );
      },
    hideModal() {
      this.$bvModal.hide("modal-create-question-auto-of-exam");
    },
    // lay dap an dung
    getMultiCorrectAnswer(index) {
      this.form.answer[index]["ans_id"] = index + 1;

      if (this.form.answer[index]["isCorrect"] === true) {
        this.form.answer[index]["isCorrect"] = false;
        this.isTrueSet[index] = false;
      } else {
        this.form.answer[index]["isCorrect"] = true;
        this.isTrueSet[index] = true;
      }
    },
    getCorrectAnswer(index) {
      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        const reqData = { ans_id: i + 1, isCorrect: false };
        this.isTrueSet[i] = false;
        this.form.answer.push(reqData);
      }
      this.isTrueSet[index] = true;
      this.form.answer[index]["ans_id"] = index + 1;
      this.form.answer[index]["isCorrect"] = true;
    },
    // so luong cau tra loi
    numberAnswerOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.number_answer = parseInt(
          e.target.options[e.target.options.selectedIndex].outerText
        );
      }
      this.valueTypeOfAnswer = [];
      if (this.alphabetAnswerSelected == 0) {
        for (let i = 0; i < this.form.number_answer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[0][i];
          this.imageReRender++;
        }
      } else {
        for (let i = 0; i < this.form.number_answer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[1][i];
          this.imageReRender++;
        }
      }
      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        const reqData = { ans_id: i + 1, isCorrect: false };
        this.isTrueSet[i] = false;
        this.form.answer.push(reqData);
      }
      this.updateCorrectAnswer++;
    },
    // the loai cau hoi
    async typeOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.type = e.target.options[
          parseInt(e.target.options.selectedIndex)
        ].outerText.trim();
      }

        // lay lai danh sach tags khi thay doi dang cau hoi:
        await this.$store.dispatch("question/changeListTags", {type: this.form.type}); // lay data tu api
       // console.log(this.changeListTags);
       this.optionsTags = this.changeListTags.data; // this.changeListTags : khai bao trong computed
       this.tagsSelected = [];
       // End lay lai danh sach tags khi thay doi dang cau hoi:

    },
    // alphabet cau hoi
    alphabetOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.alphabetAnswerSelected = parseInt([
          e.target.options.selectedIndex
        ]);
      }
      if (this.alphabetAnswerSelected == 0) {
        for (let i = 0; i < this.defaultNumberAnswer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[0][i];
          this.imageReRender++;
        }
      } else {
        for (let i = 0; i < this.defaultNumberAnswer; i++) {
          this.valueTypeOfAnswer[i] = this.valueTypeOfAnswers[1][i];
          this.imageReRender++;
        }
      }
    },
    // trang thai cau hoi
    statusOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.status = e.target.options.selectedIndex;
      }
    },
    // do kho cau hoi
    difficultyOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.difficulty =
          e.target.options[e.target.options.selectedIndex].outerText;
      }
    },
    // so luong cau tra loi chinh xac
    manyAnswerOfQuestion(e) {
      if (e.target.options.selectedIndex > -1) {
        this.form.answer_option = e.target.options[
          e.target.options.selectedIndex
        ].outerText.trim();
      }
      this.form.answer = [];
      for (let i = 0; i < this.form.number_answer; i++) {
        const reqData = { ans_id: i + 1, isCorrect: false };
        this.isTrueSet[i] = false;
        this.form.answer.push(reqData);
      }
    },
    // the loai dap an
    answerTypeOfQuestion(e) {
      let selected = "";
      if (e.target.options.selectedIndex > -1) {
        selected = e.target.options.selectedIndex;
      }
      if (selected == 0) {
        this.isText = true;
      }
      if (selected == 1) {
        this.isText = false;
      }
    },
    charCountTitle: function() {
      this.totalCharacter = this.form.title.replace(/<\/?[^>]+>/ig, "").replace(/&nbsp;/gi,' ').length;
    },
    handleAudioUpload(event) {
      // check validate
      let fileUpload = event.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];


      if (typeOfFile === "mp3") {
        if (event.target.files[0].size / 1048576 > 10) {
          this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
          });
          return;
        }
        this.audioUpload = event.target.files[0];
        this.form.audio_path = this.audioUpload;

        this.audioUpload = URL.createObjectURL(this.audioUpload);
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    handleFileUpload(e) {
        const file = e.target.files[0];
        if (!file) return;

        const extension = file.name.split(".").pop().toLowerCase();
        const allowedTypes = ["mp4", "jpg", "jpeg", "png", "pdf", "docx"];

        // Check file type
        if (!allowedTypes.includes(extension)) {
            this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
            });
            return;
        }

        // Check size (10MB)
        if (file.size / 1024 / 1024 > 10) {
            this.$bvToast.toast(this.$t(`msg["E_UC2.2_16"]`), {
            title: this.$t("difficulty.notice"),
            autoHideDelay: 5000,
            variant: "danger"
            });
            return;
        }

        // Reset preview
        this.imageUpload = null;
        this.file = null;
        this.docxPreview = null;
        this.pdfPreview = null;

        // Handle by type
        if (extension === "mp4") {
            this.form.video_path = file;
            this.file = URL.createObjectURL(file);
        }
        else if (["jpg", "jpeg", "png"].includes(extension)) {
            this.form.image_path = file;
            this.imageUpload = URL.createObjectURL(file);
        }
        else if (extension === "pdf") {
            this.form.pdf_path = file;
            this.pdfPreview = URL.createObjectURL(file);
        }
        else if (extension === "docx") {
            this.form.docx_path = file;
            this.docxPreview = file.name; // DOCX không preview trực tiếp, lấy tên file docx
        }
    },
    embed() {
      if(!this.form.embed_image_video){
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_43"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
      if (
        this.form.embed_image_video.includes("https://") ||
        this.form.embed_image_video.includes("http://") ||
        !this.form.embed_image_video.includes("<iframe")
      ) {
        this.embedUpload = this.form.embed_image_video;
        document.getElementById("embedUpload_topic").innerHTML =
          '<embed width="500" height="250" src="' +
          this.embedUpload +
          '"  frameborder="0"   allowfullscreen></embed>';
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    audioEmbedLeft() {
      if (
        this.form.embed_audio.includes("<iframe") &&
        this.form.embed_audio.includes("></iframe>") &&
        this.form.embed_audio.includes("src=")
      ) {
        this.embedAudio = this.form.embed_audio;
        document.getElementById("audio_embed_view_topic").innerHTML = this.embedAudio;
      } else {
        this.$bvToast.toast(this.$t("questions_create.message.data_invalid"), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    uploadImageAnswer(index) {
      document.getElementById("uploadImage" + index).click();
    },
    handleAnswerUpload(e, index) {
      // check validate
      let fileUpload = e.target.files[0].name.split(".");
      let typeOfFile = fileUpload[fileUpload.length - 1];

      if (
        typeOfFile === "jpg" ||
        typeOfFile === "jpeg" ||
        typeOfFile === "png"
      ) {
        const img = e.target.files[0];
        this.form.image[index] = img;
        this.answerUpload[index] = URL.createObjectURL(img);
        this.imageReRender += 1;
      } else {
        this.$bvToast.toast(this.$t(`msg["E_UC2.2_13"]`), {
          title: this.$t("difficulty.notice"),
          autoHideDelay: 5000,
          variant: "danger"
        });
        return;
      }
    },
    removeFile: function() {
      this.imageUpload = "";
      this.form.image_path = "";
      this.file = "";
      this.form.video_path = "";
      this.pdfPreview = "";
      this.docxPreview = "";
    },
    removeEmbed: function() {
      this.embedUpload = "";
      this.form.embed_image_video = "";
      document.getElementById("embedUpload_topic").innerHTML = "";
    },
    removeAudio: function() {
      this.form.audio_path = "";
      this.audioUpload = "";
      document.getElementById("upload-audio-input-topic").value = null;
    },
    removeEmbedAudio: function() {
      this.form.embed_audio = "";
      this.embedAudio = "";
      document.getElementById("embed_audio_link").value = null;
      document.getElementById("audio_embed_view_topic").innerHTML = null;
    },
    removeAnswerImage: function(index) {
      this.answerUpload[index] = "";
      this.imageReRender += 1;
    },
    async CreateQuestions() {
       // console.log(this.form.start_page);
       // console.log(this.form.end_page);
      if(this.cateSelected.length === 0){ // check danh muc ko duoc de trong
        this.$root.toast(
          this.$t(`msg["E_UC2.1_21"]`),
          "danger",
         "Danh mục không được để trống"
        );
        return false;
      }

      if(this.imageUpload === "" || this.file === "" || this.pdfPreview === "" || this.docxPreview === ""){ // check file ko duoc de trong
        this.$root.toast(
          this.$t(`msg["E_UC2.1_21"]`),
          "danger",
         "File Upload không được để trống"
        );
        return false;
      }

      this.loading = true;
      this.disable = false;
      let data = new FormData();
      for (let i = 0; i < this.cateSelected.length; i++) {
        this.form.category[i] = this.cateSelected[i]["category"];
      }
      for (let i = 0; i < this.valueTypeOfAnswer.length; i++) {
        this.form.answer[i]["ans_id"] = this.valueTypeOfAnswer[i];
      }

      for (let i = 0; i < this.tagsSelected.length; i++) {
        this.form.tags[i] = this.tagsSelected[i]["id"];
      }

    //     var arr = [];
    //   if (this.isText == false) {
    //     this.form.image.map(photo => data.append("image[]", photo, photo.name));
    //     data.append("answer_text", "");
    //   } else {
    //       for (let i = 0; i < this.valueTypeOfAnswer.length; i++) {
    //           arr.push(this.form.answer_text[i]);
    //       }
    //     data.append("answer_text", JSON.stringify(arr));
    //   }
    //  data.append("type", this.form.type);
    //  data.append("title", this.form.title);
      data.append("category", JSON.stringify(this.form.category));
    //  data.append("status", this.form.status);
    //  data.append("score", this.form.score);
    //   data.append(
    //     "difficulty",
    //     this.form.difficulty
    //       ? this.form.difficulty
    //       : this.difficulty[0]["difficulty"]
    //   );
    //  data.append("image_path", this.form.image_path);
     // data.append("video_path", this.form.video_path);
    //  data.append("embed_image_video", this.form.embed_image_video);
    //  data.append("audio_path", this.form.audio_path);
    //  data.append("embed_audio", this.form.embed_audio);
   //   data.append("answer_option", this.form.answer_option);
    //  data.append("answer_option", this.form.answer_option);
    //  data.append("explain", this.explain ? this.explain : "");
     // data.append("explain_path", this.explain_path ? this.explain_path : "");
      data.append("id_topic", this.rowTopicItem);
    //  data.append("answer", JSON.stringify(this.form.answer));
     // data.append("manyAnswer", this.form.number_answer);
     // data.append("tags", JSON.stringify(this.form.tags));

        data.append("pdf_path", this.form.pdf_path);
        data.append("docx_path", this.form.docx_path);
        data.append("start_page", this.form.start_page);
        data.append("end_page", this.form.end_page);

      this.$root.$loading.start();
      await this.$store.dispatch("question/createQuestionsAutoOfExam", data);
      const apiRes = this.$store.state.question.questionAutoOfExamResponse;
      // 👉 check type xử lý
      const resData = apiRes.data;

      // ===============================
      // DOCX → polling
      // ===============================
      if (resData.status === "processing") {

        const jobId = resData.job_tracking_id;

        this.pollJob(jobId);
        return;
      }
      // console.log('ok');
      // console.log(apiRes.status);
      // const errors =
      //   apiRes?.errors?.title ||
      //   apiRes?.errors?.score ||
      //   apiRes?.errors?.embed_audio || { message: apiRes?.message } ||
      //   "";
      // const errorFields = Object.values(errors);
      // if (this.$store.state.question.responseQuestion.code !== 422) {
      //   await this.$store.dispatch("topics/getOneTopicTest", this.rowTopicItem);
      //   this.callback();
      //   this.$root.toast(
      //     this.$t(`msg["C_UC1.2_19"]`),
      //     "success",
      //     this.$t(`msg["C_UC2.1_1"]`)
      //   );
      //   this.disable = true;
      //   this.loading = false;
      // } else {
      //   this.$root.toast(
      //     this.$t(`msg["E_UC2.1_21"]`),
      //     "danger",
      //     errorFields.toString().includes("Undefined offset")
      //       ? this.$t(`msg["E_UC2.1_26"]`)
      //       : this.$t(`msg["${errorFields}"]`)
      //   );
      //   this.loading = false;
      //   this.disable = true;
      //   return;
      // }

      if(apiRes.status === 200){
        await this.$store.dispatch("topics/getOneTopicTest", this.rowTopicItem);
        this.callback();

        this.$root.toast(
          this.$t(`msg["C_UC1.2_19"]`),
          "success",
          this.$t(`msg["C_UC2.1_1"]`)
        );
        this.disable = true;
        this.loading = false;
      }
      this.hideModal();
      this.$root.$loading.finish();
    },
    backToListQuestion() {
      this.$root.$loading.start();
      this.$router.push({ name: "QuestionList" });
      this.$root.$loading.finish();
    },
    pollJob(jobId) {

      const interval = setInterval(async () => {

        try {

          const res = await axios.get(`/job-status/${jobId}`);
          const job = res.data.data;

         // console.log("progress:", job.progress);

          // update UI
          this.progress = job.progress + this.fakeProgress;
          if(this.progress < 95){
              this.fakeProgress += Math.random() * 2;
              this.progress = this.fakeProgress + job.progress;
          }else if(this.progress >= 95 &&  job.progress < 100){
            this.progress = 99;
          }else{
            this.progress = job.progress;
          }
         // document.getElementById("progress").innerText = job.progress + "%";

          // if (job.progress >= 100) {
          //   clearInterval(interval);
          // }

          // 👉 DONE
          if (job.status === "done") {

            clearInterval(interval);

            await this.$store.dispatch("topics/getOneTopicTest", this.rowTopicItem);

            this.callback();

            this.$root.toast(
              this.$t(`msg["C_UC1.2_19"]`),
              "success",
              this.$t(`msg["C_UC2.1_1"]`)
            );

            this.loading = false;
            this.disable = true;

            this.hideModal();
            this.$root.$loading.finish();
          }

          // 👉 FAILED
          if (job.status === "failed") {

            clearInterval(interval);

            this.$root.toast(job.error_message || "Job lỗi", "danger");

            this.loading = false;
            this.disable = true;

            this.$root.$loading.finish();
          }

        } catch (e) {
          console.log("Polling error", e);
        }

      }, 4000); // 4 giây check 1 lần
    },
    checkCategoryPermission(item) {
      // Không phải tài khoản giáo viên B2B thì không cần check quyền category
            const businessId = Number(this.user?.business_id || 0);
            if (businessId <= 0) {
                return;
            }
            // ENd check tài khoản giáo viên
      const allowedIds = this.categoryIdsAllow
        .split(",")
        .map(id => String(id).trim())
        .filter(Boolean);

      const categoryId = String(item.id);

      if (!allowedIds.includes(categoryId)) {
        this.$nextTick(() => {
          this.cateSelected = this.cateSelected.filter(
            cate => String(cate.id) !== categoryId
          );
        });

        this.$root.toast(
          this.$t(`msg["title_notification"]`),
          "danger",
          this.$t(`msg["content_noti"]`),
          
        );
      }
    },
  },
  async created() {

    // Lay danh sach option Tags
    await this.$store.dispatch("question/changeListTags", {type: this.form.type});
    this.optionsTags = this.changeListTags.data;
    // End Lay danh sach option Tags

    this.form.answer = [];
    for (let i = 0; i < this.defaultNumberAnswer; i++) {
      const reqData = { ans_id: i + 1, isCorrect: false };
      this.form.answer.push(reqData);
    }
    await this.$root.$loading.start();
    await this.$store.dispatch("config/getCategory");
    this.$root.$loading.finish();
  }
};
</script>
<style>
@import "../../../assets/scss/Questions.scss";

* {
  font-size: 15px;
}

.embedIframe {
  height: 100%;
}

.embedIframe #document html {
  overflow: hidden;
}

#embed123 {
  height: 100%;
}
.embed_css {
  object-fit: cover;
  width: 500px;
  height: 250px;
}
#removeEmbed {
  position: absolute;
  right: -10px;
  z-index: 1;
  top: -10px;
  border-radius: 50px;
  width: 30px;
}
.topicDetail{
	margin-top: 20px;
	height: unset !important;
}

.topicDetail #removeEmbed{
	position: absolute;
	right: 0px;
	z-index: 1;
	top: 80px !important;
	border-radius: 50px;
	width: 30px;
}
.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable) {
    min-height: 100px;
    border: 1px solid #c4c4c4;
    overflow: auto;
}
.question-input__textArena .ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){
    width: 525px;
    resize: vertical;
}

.circle {
  position: relative;
  width: 120px;
  height: 120px;
}

.circle svg {
  transform: rotate(-90deg);
}

.circle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-weight: bold;
  font-size: 20px;
  color: #1890ff;
}
</style>
